import React, { useState, useEffect } from "react";
import innerBanner from "../../assets/images/banner/inner-banner.jpg";
import api, { baseURL } from "../api";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./ElectedWing.css"

const ElectedWing = () => {
  const [electedData, setElectedData] = useState([]);
  const { i18n, t } = useTranslation();
  const fetchElectedData = async () => {
    try {
      const response = await api.get(`/elected-wings?lang=${i18n.language}`);
      setElectedData(response.data);
    } catch (error) {
      console.error("Error fetching eleced wings data");
    }
  };

  useEffect(() => {
    fetchElectedData();
    //eslint-disable-next-line
  }, [i18n.language]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  return (
    <>
      <section className="page-title">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${innerBanner})` }}
        ></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{t("electedWings.title")}</h1>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">{t("electedWings.home")}</Link>
              </li>
              <li>
                <span>{t("electedWings.title")}</span>
              </li>
            </ul>
          </div>
        </div>

      </section>
      <div id="main-content">
        <br />
        <br />
        <br />
        <br />
        <section className="team-section sec-pad member-section">
          <div className="auto-container">
            <div className="row clearfix">
              {electedData.map((data, index) => (
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={index}>
                  <div className="profile-card gap-4">
                    <div className="card-background">
                      <div className="profile-left">
                        <img
                          src={`${baseURL}${data.image_path}`}
                          alt="Profile"
                        />
                      </div>
                    </div>


                    <div className="profile-right text-center">
                      <h4 className="name">{data.correspondentName}</h4>
                      <span className="ward">{data.wardNo}</span>
                      <p className="date">
                        {formatDate(data.startDate)} –{" "}
                        {data.endDate ? formatDate(data.endDate) : "Present"}
                      </p>
                      <span className="number d-inline-flex align-items-center justify-content-center">
                        <i className="ri-smartphone-line phone-color" />
                        {data.mobileNo}
                      </span>


                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ElectedWing;
